import {axiosRequest} from "../../api";
import {API_PATH} from "../../../constants";

export const PatientConditionService = {
  getPatientConditionsList(params){ return axiosRequest('GET', API_PATH.PATIENT_CONDITION.LIST(params)) },
  getPatientCondition(data){ return axiosRequest('POST', API_PATH.PATIENT_CONDITION.INFO, data) },
  addPatientCondition(data){ return axiosRequest('POST', API_PATH.PATIENT_CONDITION.ADD, data) },
  deletePatientCondition(data){ return axiosRequest('POST', API_PATH.PATIENT_CONDITION.DELETE, data) },
}